import React, { FC, useEffect, useState } from 'react';
import { RevistaObj } from '../../types/Types';

type Props = {
  revista: RevistaObj;
};

const RevistasIssuu: FC<Props> = ({ revista }) => {
  const [url, setUrl] = useState('');
  // bconst [showSpinner, setShowSpinner] = useState(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setUrl(
      `//e.issuu.com/embed.html?identifier=samvog76uugz&d=${revista.idIssu}&u=eroski8&p=1&embedType=script`,
    );
  });

  /* const handlerLoad = () => {
      setShowSpinner(!showSpinner);
    }; */

  const handlerError = () => {
    console.log('error');
  };

  return (
    <>
      <div className="issue u-margin-bottom-large">
        <div>
          {/* <div */}
          {/*  style={{ position: 'absolute' }} */}
          {/*  className={`loading ${showSpinner ? '' : 'display-none'}`} */}
          {/* > */}
          {/*  <img */}
          {/*    alt="spinner" */}
          {/*    src={loading_gif} */}
          {/*    style={{ */}
          {/*      width: 'auto', */}
          {/*      height: 'auto', */}
          {/*      position: 'absolute', */}
          {/*      top: 0, */}
          {/*      bottom: 0, */}
          {/*      left: 0, */}
          {/*      right: 0, */}
          {/*      margin: 'auto', */}
          {/*    }} */}
          {/*  /> */}
          {/* </div> */}
          {url && (
            <iframe
              className="issuuembed"
              src={`${url}`}
              frameBorder="0"
              allowFullScreen
              title="Issuu"
              // onLoad={handlerLoad}
              onError={handlerError}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default RevistasIssuu;
